import { getUseApi } from '@sitemax/smx-components';
import { Api } from './api';

export const useApi = getUseApi<typeof Api>();
